module.exports =  {

  alertTxt: "系统已升级为新版本（V3）",
  title: "LedgerDex系统升级公告",
  contents: `
    <p>我们很高兴地宣布：LedgerDex已经将系统升级为最新版本（V3）。</p>

    <h3 class="mb-2">为什么升级？</h3>

    <p>LedgerDex的平台是基于0x协议的。所有交易都通过0x协议的智能合约完成。最近<a href="https://blog.0xproject.com/0x-the-community-owned-liquidity-api-26da5732447e" target="_blank">0x已将智能合约升级为V3版本</a>，新版智能合约将为用户带来很多新的功能。0x的旧版智能合约将在近期内停止使用。为了配合0x智能合约的升级，我们已将LedgerDex系统升级为最新版本（V3）。</p>

    <h3 class="mb-2">新版LedgerDex有哪些新功能？</h3>

    <p>
    <ul>
      <li><strong>新版智能合约</strong>：我们支持0x的最新版智能合约（V3）。</li>
      <li><strong>流动性更强</strong>：所有交易订单都通过最新的<a href="https://blog.0xproject.com/0x-roadmap-2019-part-3-networked-liquidity-0x-mesh-9a24026202b3" target="_blank">0x Mesh网络</a>共享，市场流动性将获得大幅度提高。</li>
      <li><strong>支持手机移动端</strong>：新版LedgerDex可以通过带有dApp浏览器的手机移动端APP使用（目前支持imToken）。</li>
      <li><strong>界面更新</strong>：新版采用重新设计的界面，用户体验将大幅度增强。</li>
      <li><strong>支持跳过地域限制</strong>：虽然新版仍根据IP地址限制不支持的国家（如美国），但用户可以一键跳过这一限制，这会给在不支持地区旅行或使用IP来自不支持地区VPN的用户带来方便。</li>
      <li><strong>交易费不再只限使用ZRX代币</strong>：旧版的0x协议限制交易费（如有）只能通过ZRX代币支付，新版移除了这一限制，交易费可是使用其它代币。</li>
      <li><strong>吃单者需要付协议费</strong>：新版的0x协议增加了协议费（Protocol Fee），由吃单者承担。</li>
    </ul>
    </p>

    <h3 class="mb-2">新版（V3）和旧版（V2）的兼容性</h3>

    <p>
    <ul>
      <li>用户的代币持有量（包括WETH）保持不变。</li>
      <li>用户的代币关注列表和交易对关注列表保持不变。</li>
      <li>用户在旧版添加的代币交易授权在新版仍然有效，无需重新添加。</li>
      <li>用户在旧版生成的挂单不能在新版交易。</li>
    </ul>
    </p>

    <!--
    <h3 class="mb-2">用户需要做什么？</h3>

    <p>如果您使用过LedgerDex的旧版（V2），您可能需要通过以下步骤来配合系统升级：</p>
    <p>
    <ul>
       <li><strong>如果需要的话，取消在旧版的挂单：</strong>如果您在旧版生成过挂单，而且这些挂单目前仍然有效，您有两种选择：1) 您可以不去处理原有挂单，直到这些挂单失效或被仍然使用旧版的其他用户吃单。2) 如果您不想保留旧版挂单，您可以<a href="https://app-v2.ledgerdex.com" target="_blank">访问旧版</a>并取消该挂单。取消挂单需要花费以太坊GAS费用。</li>
    </ul>
    </p>

    <h3 class="mb-2">如何访问旧版（V2）？</h3>

    <p>为保证我们的系统升级安全顺畅，我们将在短时间内同时为用户提供平台旧版（V2）页面。旧版的链接是：<a href="https://app-v2.ledgerdex.com" target="_blank">https://app-v2.ledgerdex.com</a>。请注意我们将在不久的将来停止提供对于旧版的支持。</p>
    -->

    <p>如果您有任何问题或疑惑，请随时和我们联系！</p>
  `,

}


